import {Component, OnInit} from '@angular/core';
import {IMyDateModel} from 'mydatepicker';

@Component({
    selector: 'statistic-top-five',
    templateUrl: './templates/statistic-top-five.component.html',
    styleUrls: ['./styles/statistic-top-five.component.css']
})
export class StatisticTopFiveComponent implements OnInit {
    date_from: any;
    date_to: any;

    color = 'primary';
    mode = 'determinate';
    value = 50;
    bufferValue = 75;

    temp_list: Array<any> = [
        {item_name: 'Item 10', value: 85, bufferValue: 55},
        {item_name: 'Item 2', value: 70, bufferValue: 70},
        {item_name: 'Item 5', value: 55, bufferValue: 55},
        {item_name: 'Item 7', value: 35, bufferValue: 35},
        {item_name: 'Item 3', value: 5, bufferValue: 5}
    ];

    articles_list: Array<any> = [];
    duree_en_stock_list: Array<any> = [];
    entrees_list: Array<any> = [];
    sorties_list: Array<any> = [];
    fournisseurs_list: Array<any> = [];
    clients_list: Array<any> = [];

    constructor() {
        this.articles_list = this.temp_list;
        this.duree_en_stock_list = this.temp_list;
        this.entrees_list = this.temp_list;
        this.sorties_list = this.temp_list;
        this.fournisseurs_list = this.temp_list;
        this.clients_list = this.temp_list;
    }

    ngOnInit() {
    }

    onDate1Changed(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date_from = "";
        } else {
            this.date_from = event.jsdate.toLocaleDateString("en-US");
        }
    }
    onDate2Changed(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date_to = "";
        } else {
            this.date_to = event.jsdate.toLocaleDateString("en-US");
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/statistic-top-five.component.ts